const HeaderNav =  ({label, openInMobile}) => {

    return (
        <nav aria-label={label} className={`nav ${openInMobile ? 'nav-open':''}`}>
            <ul>
                <li className="provider-login dt">
                    <a href="https://app.sal.health/" target="_blank" rel="noreferrer">
                    <img src="https://www.salubrishealth.com/images/health-hub.svg" alt="Login to our provider portal" /></a>
                </li>
                <li>
                    <a href="https://www.salubrishealth.com/contact">Contact</a>
                </li>
                <li><a href="https://www.salubrishealth.com/find-doctors" className="on">Find a Doctor</a></li>
                <li><a href="https://www.salubrishealth.com/health-plans">For Health Plans</a></li>
                <li><a href="https://www.salubrishealth.com/providers">For Providers</a></li>
                <li><a href="https://www.salubrishealth.com/about">About</a></li>
                <li><a href="https://www.salubrishealth.com/" className="mb">Home</a></li>
                <li><a href="https://app.sal.health/" target="_blank" className="mb" rel="noreferrer">Sal Health Hub</a></li>
            </ul>
        </nav>
    )
}

export default HeaderNav;